export const FETCH_DID_NUMBER_LISTING               =   "FETCH_DID_NUMBER_LISTING"
export const FETCH_UNASSIGNED_DID_NUMBER_LISTING    =   "FETCH_UNASSIGNED_DID_NUMBER_LISTING"
export const CALL_REPORT                            =   'CALL_REPORT'